import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

interface IdItem {
    id: string;
    isFree: boolean;
}
interface UnityIdsResponse {
    districts: Array<IdItem>;
    locations: Array<IdItem>;
}

const ENDPOINT = '/api/unity-ids/v2';

export const useUnityIds = () => {
    return useQuery({
        queryKey: [ENDPOINT],
        queryFn: async () => {
            const response = await axios.get<UnityIdsResponse>(ENDPOINT);
            return response.data;
        },
    });
};
